import brand from './brand';
import cart from './cart';
import checkout from './checkout';
import confirmation from './confirmation';
import globalEvents from './global';
import homepage from './homepage';
import landing from './landing';
import product from './product';
import search from './search';
import rewards from './rewards';

// Mapping needs to match up with getType() output
export default {
  brand,
  cart,
  checkout,
  confirmation,
  globalEvents,
  homepage,
  landing,
  product,
  rewards,
  search
};
